import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import innovation from "../../assests/ServiceTabs/Innovation.svg";
// import Rectangle from "../../assests/ServiceTabs/Rectangle.png";
import WaydoneLogo from "../../assests/waydone-logo.svg"
import "./Innovation.css";

const Innovation: React.FC = () => {
  return (
    <>
   
      {/* Section Heading */}
 <Container className="text-center mb-5 d-flex flex-column align-items-center mt-5" id="product">
        <h3 className="Products"> <span className="dot"></span>Our Product</h3>
        <h1 className="xyloite-o">Your Vision, Our Innovation</h1>
      </Container>
 <div style={{display:"flex",justifyContent:"center"}}>
      {/* Content */}
      <div className="waydone-inovation-container">
      <div className="waydone-container">
        <Row className="align-items-center">
          {/* Left Column - Image + Text */}
          <Col xs={12} md={7} className="mb-4 mb-md-0 left-column">
            <img
              src={WaydoneLogo}
              alt="Dashboard Preview"
              className="dashboard-image mb-3"
            />
            <h2>
              <span className="highlight-innovation">WayDone.AI</span>
            </h2>
            <h4 className="innovation-h4">The Enterprise AI Enablement Platform </h4>
            <p className="innovation-p">
              AI enablement platform that transforms your existing systems into intelligent, automated, and data-driven solutions. It empowers businesses to accelerate innovation, optimize workflows, and enhance customer engagement effortlessly.
 
            </p>
           <div
            className="explore-product"
            onClick={() => window.open("https://waydone.ai", "_blank")}
            style={{ cursor: "pointer" }} // makes it show a pointer on hover
          >
            Explore Product →
          </div>

          </Col>

          {/* Right Column - Logo */}
          <Col xs={12} md={5} className="text-center">
            <img src={innovation} alt="Waydone.AI Logo" className="logo img-fluid" />
          </Col>
        </Row>
      </div>
      </div>
      </div>
    </>
  );
};

export default Innovation;
